<template>
  <div class="container-fluid p-3">
    <form>
      <div class="form-group">
        <label for="recurrenceType">Tipo de Recorrência</label>
        <select v-model="recurrenceType" class="form-control custom-select" id="recurrenceType">
          <option value="daily">Diária</option>
          <option value="weekly">Semanal</option>
          <option value="monthly">Mensal</option>
        </select>
      </div>
      <div class="form-group">
        <label for="time">Horário</label>
        <input type="time" v-model="cron.time" class="form-control" id="time" />
      </div>

      <div v-if="recurrenceType === 'weekly'" class="form-group">
        <label for="weeklyDays">Dias da Semana</label>
        <v-select
          v-model="cron.daysOfWeek"
          :options="dayOfWeekOptions"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          placeholder="Selecione os dias"
          label="name"
          track-by="id"
          id="weeklyDays"
        />
      </div>

      <div v-if="recurrenceType === 'monthly'" class="form-group">
        <label for="monthlyDays">Dias do Mês</label>
        <v-select
          v-model="cron.daysOfMonth"
          :options="dayOfMonthOptions"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          placeholder="Selecione os dias do mês"
          label="name"
          track-by="value"
          id="monthlyDays"
        />
      </div>
    </form>

    <div class="mt-5 p-3 bg-light border rounded">
      <h4 class="text-center">Recorrência</h4>
      <p class="text-center font-weight-bold text-primary">{{ formattedExpression }}</p>
    </div>
  </div>
</template>

<script>
import DefaultButton from '@/components/UI/button/defaultButton.vue'

export default {
  name: 'RecurrenceForm',
  components: {
    DefaultButton
  },
  props: {
    triggerGenerate: {
      type: Boolean,
      default: false
    },
    cronExpression: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      recurrenceType: 'daily',
      cron: {
        time: '12:00',
        daysOfWeek: [],
        daysOfMonth: []
      },
      dayOfWeekOptions: [
        { id: 0, name: 'Domingo' },
        { id: 1, name: 'Segunda-feira' },
        { id: 2, name: 'Terça-feira' },
        { id: 3, name: 'Quarta-feira' },
        { id: 4, name: 'Quinta-feira' },
        { id: 5, name: 'Sexta-feira' },
        { id: 6, name: 'Sábado' }
      ],
      dayOfMonthOptions: Array.from({ length: 31 }, (_, i) => ({
        value: i + 1,
        name: `Dia ${i + 1}`
      }))
    }
  },
  watch: {
    triggerGenerate (newVal) {
      if (newVal) {
        this.generateCron()
      }
    },
    cronExpression: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.parseCronExpression(newVal)
        }
      }
    }
  },
  computed: {
    formattedExpression () {
      switch (this.recurrenceType) {
        case 'daily':
          return `Diariamente no horário: ${this.cron.time}`
        case 'weekly':
          return this.cron.daysOfWeek.length
            ? `Semanalmente nos dias: ${this.cron.daysOfWeek
              .map((day) => day.name)
              .join(', ')}, no horário: ${this.cron.time}`
            : 'Nenhum dia selecionado para recorrência semanal'
        case 'monthly':
          return this.cron.daysOfMonth.length
            ? `Mensalmente nos dias: ${this.cron.daysOfMonth
              .map((day) => day.name)
              .join(', ')}, no horário: ${this.cron.time}`
            : 'Nenhum dia selecionado para recorrência mensal'
        default:
          return 'Configuração inválida'
      }
    }
  },
  methods: {
    generateCron () {
      let cronExpression = ''
      const [hour, minute] = this.cron.time.split(':')

      switch (this.recurrenceType) {
        case 'daily':
          cronExpression = `${minute} ${hour} * * *`
          break
        case 'weekly':
          const daysOfWeek = this.cron.daysOfWeek.map((day) => day.id).join(',')
          cronExpression = `${minute} ${hour} * * ${daysOfWeek}`
          break
        case 'monthly':
          const daysOfMonth = this.cron.daysOfMonth.map((day) => day.value).join(',')
          cronExpression = `${minute} ${hour} ${daysOfMonth} * *`
          break
        default:
          cronExpression = 'Configuração inválida'
      }

      this.$emit('cron-generated', cronExpression)
      console.log(cronExpression)
    },
    parseCronExpression (cron) {
      const [minute, hour, dayOfMonth, , dayOfWeek] = cron.split(' ')

      if (dayOfMonth === '*' && dayOfWeek === '*') {
        this.recurrenceType = 'daily'
        this.cron.time = `${hour}:${minute}`
      } else if (dayOfWeek !== '*') {
        this.recurrenceType = 'weekly'
        this.cron.time = `${hour}:${minute}`
        this.cron.daysOfWeek = dayOfWeek.split(',').map(day =>
          this.dayOfWeekOptions.find(option => option.id === parseInt(day, 10))
        )
      } else if (dayOfMonth !== '*') {
        this.recurrenceType = 'monthly'
        this.cron.time = `${hour}:${minute}`
        this.cron.daysOfMonth = dayOfMonth.split(',').map(day =>
          this.dayOfMonthOptions.find(option => option.value === parseInt(day, 10))
        )
      }
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/component/ModalPeriodicidade.vue